import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 1H5v18h18V1zm-2 16H7V3h14v14zM3 5H1v18h18v-2H3V5zm14 10V5h-6v2h4v2h-2v2h2v2h-4v2h6z"
}), 'Filter3Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Filter3Sharp.js
// module id = 3588
// module chunks = 2